var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadDocDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.74 9.44H2V6.42C2 3.98 3.98 2 6.42 2H8.75C10.38 2 10.89 2.53 11.54 3.4L12.94 5.26C13.25 5.67 13.29 5.73 13.87 5.73H16.66C19.03 5.72 21.05 7.28 21.74 9.44Z",
    fill: "#A461D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.99 10.8375C21.97 10.3475 21.89 9.8875 21.74 9.4375H2V16.6475C2 19.5975 4.4 21.9975 7.35 21.9975H16.65C19.6 21.9975 22 19.5975 22 16.6475V11.0675C22 10.9975 22 10.9075 21.99 10.8375ZM14.5 16.2475H12.81V17.9975C12.81 18.4075 12.47 18.7475 12.06 18.7475C11.65 18.7475 11.31 18.4075 11.31 17.9975V16.2475H9.5C9.09 16.2475 8.75 15.9075 8.75 15.4975C8.75 15.0875 9.09 14.7475 9.5 14.7475H11.31V12.9975C11.31 12.5875 11.65 12.2475 12.06 12.2475C12.47 12.2475 12.81 12.5875 12.81 12.9975V14.7475H14.5C14.91 14.7475 15.25 15.0875 15.25 15.4975C15.25 15.9075 14.91 16.2475 14.5 16.2475Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocDark);
export default __webpack_public_path__ + "static/media/upload-doc-dark.d8561a86465bff6098f0cc202006b031.svg";
export { ForwardRef as ReactComponent };